import { buildProperty, buildCollection } from "@firecms/core";
import enumLocales from "./locales.enum";
import uniqid from "uniqid";

interface IBlog {
  author: string;
  publishDate: Date;
  category: string;
  tags: Array<string>;
  published: boolean;
  featuredImage: string;
  link: string;
}

const BlogLocaleSchema = buildCollection({
  id: "blog_locales",
  name: "Locale",
  path: "locales",
  customId: enumLocales,
  properties: {
    title: buildProperty({
      name: "Title",
      dataType: "string",
      columnWidth: 400,
      validation: { required: true },
    }),
    excerpt: buildProperty({
      name: "Excerpt",
      dataType: "string",
      columnWidth: 400,
      markdown: true,
      validation: { required: true },
    }),
    content: buildProperty({
      name: "Content",
      dataType: "string",
      columnWidth: 400,
      markdown: true,
      validation: { required: true },
    }),
    metaDescription: buildProperty({
      name: "Meta Description",
      dataType: "string",
      columnWidth: 400,
      multiline: true,
    }),
  },
});

const BlogSchema = buildCollection<IBlog>({
  id: "blog",
  name: "Blog",
  path: "blog",
  subcollections: [BlogLocaleSchema],
  properties: {
    author: buildProperty({
      name: "Author",
      dataType: "string",
      validation: { required: true },
    }),
    publishDate: buildProperty({
      name: "Publish Date",
      dataType: "date",
      mode: "date_time",
      validation: { required: true },
    }),
    category: buildProperty({
      name: "Category",
      dataType: "string",
      validation: { required: true },
      enumValues: {
        general: "General",
        news: "News",
        guides: "Guides",
        events: "Events",
      },
    }),
    tags: buildProperty({
      name: "Tags",
      dataType: "array",
      of: {
        dataType: "string",
      },
    }),
    published: buildProperty({
      name: "Published",
      dataType: "boolean",
      defaultValue: false,
    }),
    featuredImage: {
      name: "Featured image",
      dataType: "string",
      storage: {
        fileName: () => uniqid(),
        acceptedFiles: ["image/*"],
        storagePath: "images/blog",
        metadata: {
          cacheControl: "max-age=1000000",
        },
      },
    },
    link: buildProperty({
      name: "Publication Link",
      dataType: "string",
      validation: { required: false },
      config: {
        url: true,
      },
    }),
  },
});

export default BlogSchema;
export { BlogLocaleSchema };

